import { Card, CardContent } from "./ui/card";
import { Loader2 } from "lucide-react";

export function LoadingSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Card className="w-full max-w-md">
        <CardContent className="flex flex-col items-center justify-center p-8">
          <Loader2 className="h-8 w-8 animate-spin text-primary mb-4" />
          <h3 className="text-lg font-medium mb-2">Loading...</h3>
          <p className="text-sm text-muted-foreground text-center">
            Please wait while we authenticate you.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}